var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-delete-button',{attrs:{"resource":_vm.listState.resource,"text":false},on:{"delete":_vm.onBulkDelete}})}
var staticRenderFns = []

export { render, staticRenderFns }